






import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class TableCell extends Vue {
  @Prop({ required: true })
  readonly tag: string
}
